import { yupResolver } from "@hookform/resolvers/yup";
import { Typography, Stack, IconButton, TextField, Grid, Autocomplete, Button, } from "@mui/material"
import { CloseIcon } from "components/Icons"
import SaveIcon from '@mui/icons-material/SaveOutlined'
import { BasePathProvider } from "components/Providers"
import { Controller, useForm } from "react-hook-form";
import * as yup from 'yup'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { saveSchool } from "store/application/student-applications";
import { useEffect } from "react";
import { search } from "store/application/application-setting";


function UpdateSchoolApplication({ applicationRecord, setOpenDrawer, setApplicationRecord, selectedSchool }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const types = useSelector(state => state.lookup.types)?.filter(item => item.category === 'applicationStatus')
    const schools = useSelector(state => state.application.applicationSetting.list);
    const siblingCheckOptions = [
        { label: 'Sibling Confirmed', value: true },
        { label: 'Sibling Ineligible', value: false },
    ];

    useEffect(() => {
        if (!schools) dispatch(search());
    }, [schools, dispatch]);


    const schema = yup.object().shape({});

    const { control, handleSubmit } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            status: selectedSchool?.status || null,
            notes: selectedSchool?.notes || '',
            siblingCheck: selectedSchool?.siblingCheck ?? null,
        },
    });

    const onSubmit = async (data) => {

        const payload = {
            status: data.status,
            notes: data.notes,
            siblingCheck: data.siblingCheck,
        };

        try {
            const res = await dispatch(saveSchool({ id: selectedSchool.id, ...payload }));

            if (res.payload) {
                setApplicationRecord(prev => ({
                    ...prev,
                    ...res.payload,
                    school: prev.school,
                }));
                setOpenDrawer(false);
            } else {
                console.error('Save failed:', res);
            }
        } catch (error) {
            console.error('Save error:', error);
        }
    };

    return (
        <BasePathProvider value={() => setOpenDrawer(false)}>
            <Stack sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }} direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" fontWeight={300}>
                    {`Update ${selectedSchool?.school?.name} Application Status for ${applicationRecord?.firstName} ${applicationRecord?.lastName}`}
                </Typography>
                <IconButton aria-label="close" onClick={() => setOpenDrawer(false)}>
                    <CloseIcon />
                </IconButton>
            </Stack>

            <Grid container spacing={1.5} sx={{ p: 2 }} component="form" onSubmit={handleSubmit(onSubmit)}>
                <Grid item xs={12}>
                    <Controller
                        name="status"
                        control={control}
                        render={({ field, fieldState }) => {
                            const selectedOption = types.find(option => option.code === field.value) || null;

                            return (
                                <Autocomplete
                                    options={types}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.code === value.code}
                                    value={selectedOption}
                                    onChange={(_, newValue) => field.onChange(newValue ? newValue.code : null)}
                                    sx={{ flex: 1 }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Status"
                                            variant="outlined"
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            size="small"
                                            fullWidth
                                        />
                                    )}
                                />
                            );
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="notes"
                        control={control}
                        render={({ field, fieldState }) => (
                            <TextField
                                {...field}
                                label="Notes"
                                variant="outlined"
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                size="small"
                                fullWidth
                                multiline
                                minRows={2}
                                maxRows={6}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="siblingCheck"
                        control={control}
                        render={({ field, fieldState }) => {
                            const selectedOption = siblingCheckOptions.find(option => option.value === field.value) || null;

                            return (
                                <Autocomplete
                                    options={siblingCheckOptions}
                                    getOptionLabel={option => option?.label || ''}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    value={selectedOption}
                                    onChange={(_, newValue) => field.onChange(newValue ? newValue.value : null)}
                                    sx={{ flex: 1 }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Sibling Check"
                                            variant="outlined"
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            size="small"
                                            fullWidth
                                        />
                                    )}
                                />
                            );
                        }}
                    />
                </Grid>

                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="submit" variant="contained" startIcon={<SaveIcon />}>
                        {t('Submit')}
                    </Button>
                </Grid>
            </Grid>
        </BasePathProvider>
    );
}

export default UpdateSchoolApplication;
